import { HttpClient } from '@angular/common/http';
import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription, tap } from 'rxjs';

import { SystemMessage, SystemMessageService } from 'app/core/system-message/system-message-service';
import { validateForm } from 'app/shared/form-elements/form-validateForm.function';
import { RepositoryRegistrationVm } from 'app/shared/generated/Models/Public/RepositoryRegistrationVm';
import { RecaptchaService } from 'app/services/recaptcha.service';

@Component({
    selector: 'pcg-repository-register',
    templateUrl: './repository-register.component.html',
    styleUrls: ['./repository-register.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RepositoryRegisterComponent {

	honeypotControl;

	id: number;
	formGroup = RepositoryRegistrationVm.Form;
	model = RepositoryRegistrationVm.GetModel(this.formGroup);
	model$: Observable<RepositoryRegistrationVm>;
	subscriptions = new Subscription();
	currentDate: Date = new Date();
	canManualEntry = true;
	isSuccess = false;
	disableSave = false;

	phoneValidation = { pattern: "Invalid phone number" };

    isSubmitting = signal<boolean>(false);

	constructor(
        private route: ActivatedRoute
        , private httpClient: HttpClient
        , title: Title
        , private ms: SystemMessageService
        , private recaptchaService : RecaptchaService
    ) {
		title.setTitle('Register Repository');
	}

	ngOnInit() {
		this.setUpHoneyPot();
		this.formGroup.get('dateSigned').patchValue(this.currentDate.toLocaleString());
	}

	setUpHoneyPot() {
		this.formGroup.controls['honeyPot'].setValidators(this.requireFalse());
		this.formGroup.updateValueAndValidity();
	}

	requireFalse(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (control.value === true) { return { honeyPot: true }; }
			return null;
		}
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	getRepository() {
		this.subscriptions.add(this.route.paramMap.subscribe(map => {
			this.id = parseInt(map.get('id'), 10);

			if (this.id !== 0) {
				this.model$ = this.httpClient
					.get(`api/RxConnects/Repository/GetRepositoryDetails/${this.id}`)
					.pipe(tap((model: RepositoryRegistrationVm) => {
						this.formGroup.patchValue(model);
					}));
			} else { this.formGroup.get('dateSigned').patchValue(this.currentDate.toLocaleString()); }
		}));
	}

    saveRepository() {
		if (!(this.formGroup.valid && this.formGroup.get('isAttested').value)) {
            validateForm(this.formGroup); 
            return;
		} 

        // Submit with reCAPTCHA protection
        this.recaptchaService.submit(
            {
                action: 'saveRxConnectsRepository',
                apiEndpoint: 'api/PublicRepositoryRegister/saveRepository/',
                formGroup: this.formGroup,
                loadingSignal: this.isSubmitting
            },
            {
                onSuccess: (msg: SystemMessage) => {
                    if (msg.isSuccessful) {
                        this.isSuccess = true;
                        this.disableForm();
                    } else {
                        this.isSuccess = false;
                        this.ms.setSystemMessage(msg.message, "error");
                    }
                }
            }
        );
	}

	disableForm() {
		this.formGroup.disable();
		this.disableSave = true;
	}

	updateCounty() {
		const address = this.formGroup.value.smartyAddress;

		if (address === null || address.countyName === null) { return; }
		this.httpClient.get(`api/PublicRepositoryRegister/GetCountyByName?countyName=${address.countyName}`).subscribe((countyId: number) => {
			if (countyId !== 0) {
				this.formGroup.get('countyId').patchValue(countyId)
				document.getElementById('pharmacistName').focus();
			}
			else {
				this.formGroup.get('countyId').patchValue(0)
				document.getElementById('countyId').focus();
			}
		});
	}
}
